import { createContext, use } from "react";
import type { IDialogContext } from "./types";

export const DialogContext = createContext<IDialogContext | null>(null);

export const useDialogContext = (): IDialogContext => {
  const context = use(DialogContext);
  if (!context) {
    throw new Error("Dialog parts must be rendered inside a Modal or Drawer");
  }
  return context;
};
